'use client';

import { useEffect } from 'react';
import { applyTheme, normalizeTheme } from '@/components/tenant/theme/theme-options';

const API_URL = process.env.NEXT_PUBLIC_API_URL ?? 'http://localhost:3001';

/**
 * Variante client-side do AuthThemeApplier. Usado em paginas de auth
 * que sao 'use client' (reset-password, verify-email) e nao podem
 * receber a config diretamente do server component que as renderiza.
 *
 * Faz fetch de /platform/config no mount e aplica o tema escolhido
 * pelo SUPER_ADMIN. Aceita um flicker minimo (do default para o tema
 * salvo) - aceitavel nesses fluxos secundarios; o /login e /register,
 * que sao a vitrine principal, usam o AuthThemeApplier server-side
 * sem flicker.
 */
export function AuthThemeClient() {
  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/v1/platform/config`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('platform config unavailable'))))
      .then((cfg: { loginTheme?: string }) => {
        if (cancelled) return;
        applyTheme(normalizeTheme(cfg.loginTheme ?? '7cors-client'));
      })
      .catch(() => {
        // mantem default vindo do html data-theme; sem ruido em log de prod
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
